import React from 'react';
const BoardContext = React.createContext({});
BoardContext.displayName = 'BoardContext';
export default BoardContext;